import axios from '../api/index.js';

//查询轮播列表
export let getBannerQuery = (params) => {
    return axios.post(`/client/rotation/list?dictId=${params}`);
};








// WEBPACK FOOTER //
// ./src/api/banner.js